import React from 'react';
import { Col } from 'shards-react';
import classNames from 'classnames';

type PageTitleProps = React.ComponentProps<Col> & {
  title: string;
  subtitle: string;
  className: string;
};

const PageTitle = ({ title, subtitle, className, ...attrs }: PageTitleProps) => {
  const classes = classNames(className, 'text-center', 'text-md-left', 'mb-sm-0');

  return (
    <Col xs="12" sm="4" className={classes} {...attrs}>
      <span className="text-uppercase page-subtitle">{subtitle}</span>
      <h3 className="page-title">{title}</h3>
    </Col>
  );
};

export default PageTitle;
